import { render, staticRenderFns } from "./VueSaxGeneralTypeaheadTemplate.vue?vue&type=template&id=23609c44&scoped=true"
import script from "./VueSaxGeneralTypeaheadTemplate.vue?vue&type=script&lang=js"
export * from "./VueSaxGeneralTypeaheadTemplate.vue?vue&type=script&lang=js"
import style0 from "./VueSaxGeneralTypeaheadTemplate.vue?vue&type=style&index=0&id=23609c44&prod&scoped=true&lang=css"
import style1 from "./VueSaxGeneralTypeaheadTemplate.vue?vue&type=style&index=1&id=23609c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23609c44",
  null
  
)

export default component.exports